import '@webModules/scrollState';
import { invoke } from '@shared/easyfy.decorators';
import { globalEvent, element } from '@shared/easyfy.core';
import PrescriptionModal, {
  ModalType
} from '@webModules/prescriptionModal';

namespace Easyfy.Web.Pages.Prescription {
  @invoke
  class MyPrescriptionsFaq {
    static Instance: MyPrescriptionsFaq;

    private modal: PrescriptionModal;

    constructor() {
      MyPrescriptionsFaq.Instance = this;
      this.modal = new PrescriptionModal();
    }

    onInit() {
      globalEvent({
        type: 'click',
        event: {
          action: 'open-how-to-modal',
          callback: MyPrescriptionsFaq.GetHowToModal
        }
      });
    }

    static GetHowToModal = (e: Event) => {
      e.preventDefault();
      e.stopPropagation();
      const addToElement = element(
        '[data-container="prescription-faq-page"]'
      ) as HTMLElement;
      if (!addToElement) {
        return;
      }

      MyPrescriptionsFaq.Instance.modal.AppendModal(
        ModalType.HowTo,
        addToElement
      );
    };
  }
}

export default Easyfy.Web.Pages;
